import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const PopUpPreview = ({ listItems = [] }) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundColor: "gray",
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "60px",
            backgroundColor: "black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <i
            className="bx bx-sm bx-x py-1 px-1"
            style={{ cursor: "pointer", color: "white" }}
          />
          <p
            style={{
              textAlign: "center",
              color: "white",
              fontSize: "14px",
            }}
          >
            {listItems[0]?.line1}
          </p>
        </div>
        {listItems[0]?.image && listItems[0]?.image?.editedImage && (
          <div
            style={{
              backgroundImage: `url(${listItems[0]?.image?.editedImage})`,
              width: "100%",
              height: "30%",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        )}
        <p className="mx-1 my-2" style={{ color: "white" }}>
          {listItems[0]?.line2}
        </p>
        <p className="mx-1 my-2" style={{ color: "white" }}>
          {listItems[0]?.line3}
        </p>
        <div
          dangerouslySetInnerHTML={{ __html: listItems[0]?.details }}
          className="ms-1"
          style={{ fontSize: "10px", color: "white" }}
        />
      </div>
    </PhoneArea>
  )
}

export default PopUpPreview
